import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { useDishesByLocation } from 'features/dishes/api/getDishes';
import { useEnabledLocations } from 'features/locations/api/getLocations';
import { Control, Controller, UseFormWatch } from 'react-hook-form';

interface Props {
  control: Control<{
    location_id: number;
    dish_id: number;
    duration: number;
    analyzerId: number;
    snapshotId: number;
  }>;
  watch: UseFormWatch<{
    location_id: number;
    dish_id: number;
    duration: number;
    analyzerId: number;
    snapshotId: number;
  }>;
  getConstraints: () => void;
}

const ForecastReflectionFilters = ({
  control,
  watch,
  getConstraints,
}: Props) => {
  const { data: locations } = useEnabledLocations({});
  const { data: dishes } = useDishesByLocation({
    locationId: watch('location_id'),
  });
  return (
    <Grid container spacing={1} item xs alignItems='center'>
      <Controller
        name='location_id'
        control={control}
        render={({ field: { onChange, value } }) => (
          <Grid item style={{ minWidth: '10rem' }}>
            <FormControl fullWidth>
              <InputLabel id='location-select-label'>Location</InputLabel>
              <Select
                labelId='location-select-label'
                label='Location'
                id='location_id'
                name='location_id'
                onChange={(e) => onChange(e.target.value)}
                value={value}
              >
                <MenuItem key='0' value={'0'}>
                  <em>None</em>
                </MenuItem>
                {locations &&
                  locations?.map((location) => (
                    <MenuItem key={location.id} value={location.id}>
                      {location.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
        )}
      />
      <Controller
        name='dish_id'
        control={control}
        render={({ field: { onChange, value } }) => (
          <Grid item style={{ minWidth: '10rem' }}>
            <FormControl fullWidth>
              <InputLabel id='dish-select-label'>Dish</InputLabel>
              <Select
                labelId='dish-select-label'
                label='Dish'
                id='dish_id'
                name='dish_id'
                onChange={(e) => onChange(e.target.value)}
                value={value}
              >
                <MenuItem key='0' value={'0'}>
                  <em>None</em>
                </MenuItem>
                {dishes &&
                  dishes?.map((dish) => (
                    <MenuItem key={dish.id} value={dish.id}>
                      {dish.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
        )}
      />
      <Grid item>
        <Button onClick={getConstraints} variant='contained'>
          Get Alerts
        </Button>
      </Grid>
    </Grid>
  );
};

export default ForecastReflectionFilters;
